import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path d="M19.975 11h-13.6l5.3-5.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-7 7c-.1.1-.2.2-.2.3-.1.3-.1.5 0 .8.1.1.1.2.2.3l7 7c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-5.3-5.3h13.6c.6 0 1-.4 1-1s-.4-1-1-1z" />,
  'ArrowBack'
)
